(function () {
  var MAP = {}, COLOR_IDX = -1;
  function pathOf(u) { try { return new URL(u, location.href).pathname; } catch (e) { return ''; } }

  function injectSwatchCss() {
    var css = '';
    for (var val in MAP) {
      var sel = 'variant-picker label:has(input[value="' + val.replace(/"/g, '\\"') + '"])';
      css += sel + '{background-image:url(' + MAP[val] + ');' +
             'background-size:cover;background-position:top center;' +
             'width:74px !important;min-width:74px !important;max-width:74px !important;' +
             'height:74px !important;padding:0 !important;color:transparent !important;' +
             'overflow:hidden;font-size:0 !important;}' +
             sel + ' span{display:none !important;}';
    }
    css += '@media (max-width:749px){variant-picker label.brand-sq, variant-picker label:has(input[data-brand-swatch]){width:60px !important;min-width:60px !important;height:60px !important;}}';
    var st = document.createElement('style');
    st.id = 'brand-swatch-css';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function markInputs() {
    document.querySelectorAll('variant-picker input').forEach(function (inp) {
      if (MAP[inp.value]) inp.setAttribute('data-brand-swatch', '1');
    });
  }

  // INSTANT slide: jump the gallery to the colour's image the moment the input changes,
  // without waiting for the server round-trip.
  function instantSlide(val) {
    var src = MAP[val];
    if (!src) return;
    var want = pathOf(src);
    var gallery = document.querySelector('.product-information media-gallery') || document.querySelector('media-gallery');
    if (!gallery || !gallery.slideshow) return;
    var imgs = Array.prototype.filter.call(gallery.querySelectorAll('slideshow-slide img'), function (img) {
      return !img.closest('dialog');
    });
    for (var i = 0; i < imgs.length; i++) {
      if (pathOf(imgs[i].currentSrc || imgs[i].src) === want) {
        try { gallery.slideshow.select(i); } catch (e) {}
        return;
      }
    }
  }

  function init() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) {
      (p.options || []).forEach(function (o, i) {
        var n = (o.name || o).toString().toLowerCase();
        if (n === 'colour' || n === 'color') COLOR_IDX = i;
      });
      if (COLOR_IDX < 0) return;
      (p.variants || []).forEach(function (v) {
        var val = v.options[COLOR_IDX];
        if (!MAP[val] && v.featured_image && v.featured_image.src) MAP[val] = v.featured_image.src;
      });
      injectSwatchCss();
      markInputs();
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.tagName === 'INPUT' && MAP[t.value] && t.closest('variant-picker')) {
          instantSlide(t.value);
        }
      }, true);
      new MutationObserver(markInputs).observe(document.body, { childList: true, subtree: true });
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
